export const CURRENT_CHECKED = 'CURRENT_CHECKED';
export const CHECKED = 'CHECKED';
export const DISABLED = 'DISABLED';
export const WEB_DEVICE = 'WEB';
export enum LEVEL {
    LEVEL_0 = 'A',
    LEVEL_1 = 'B',
    LEVEL_2 = 'C',
    LEVEL_3 = 'D',
    LEVEL_4 = 'E',
    LEVEL_5 = 'F',
    LEVEL_6 = 'G',
    LEVEL_7 = 'H'
}
export enum STEPS_GRAPH_CMS {
    STEP_BUREAU = 'Bureau',
    STEP_STEP_8 = 'Step_8',
    STEP_STEP_7 = 'Step_7',
    STEP_STEP_6 = 'Step_6',
    STEP_STEP_5 = 'Step_5',
    STEP_STEP_4 = 'Step_4',
    STEP_STEP_3 = 'Step_3',
    STEP_STEP_2 = 'Step_2',
    STEP_STEP_1 = 'Step_1',
    STEP_STEP_0 = 'Step_0'
}